/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SingleDiffusionList } from '../../models/single-diffusion-list';

export interface RetrieveDiffusionList$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function retrieveDiffusionList(http: HttpClient, rootUrl: string, params: RetrieveDiffusionList$Params, context?: HttpContext): Observable<StrictHttpResponse<SingleDiffusionList>> {
  const rb = new RequestBuilder(rootUrl, retrieveDiffusionList.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SingleDiffusionList>;
    })
  );
}

retrieveDiffusionList.PATH = '/users/diffusionlist/{uid}';
